import React from "react";
import "./FitnessAndFootballPage.scss";

import { Helmet } from "react-helmet-async";
import { Body, BodyHeading, BodyContent } from "@thrivetribe/mvf.ui.organisms.body";
import { Banner, BannerContent } from "@thrivetribe/mvf.ui.molecules.banner";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { FullWidthCta, CtaContent, CtaImage } from "@thrivetribe/mvf.ui.molecules.full-width-cta";
import { useGetBannerQuery, useGetBookletQuery } from "redux/contentApiSlice";
import { ArticleListing } from "ui/molecules/ArticleListing";
import { PageIntro } from "ui/atoms/PageIntro/PageIntro";
import { LoadingSpinner } from "@thrivetribe/mvf.ui.molecules.loading-spinner";

interface FitnessAndFootballProps {}

export const FitnessAndFootball: React.FC<FitnessAndFootballProps> = (props: FitnessAndFootballProps) => {
  const { data: banner, isLoading: isBannerLoading } = useGetBannerQuery("get-moving-with-man-v-fat-gym");
  const { data: booklet, isLoading: isBookletLoading } = useGetBookletQuery("exercise-101");

  if (isBannerLoading || isBookletLoading) {
    return <LoadingSpinner fullscreen={false} />;
  }

  return (
    <Body className="fitness-football-page">
      <Helmet>
        <title>Fitness &amp; Football - MAN v FAT</title>
      </Helmet>
      <BodyHeading>
        <h1>Fitness and football</h1>
      </BodyHeading>
      <BodyContent>
        <PageIntro>
          Check out our home exercise guide, head to MAN v FAT Gym or brush up on your fitness and physical activity
          know-how.
        </PageIntro>
        <h2 className="booklet__heading">Download our exercise guide</h2>
        {booklet !== undefined && (
          <FullWidthCta reactRouterTo={`https:${booklet.pdf.file.url}`} target="_blank">
            <CtaContent>
              <h2>{booklet.title}</h2>
              <p>{booklet.body}</p>
              <Button tabIndex={-1} onClick={() => {}} variant="text">
                {booklet.ctaCopy}
                <ButtonArrow />
              </Button>
            </CtaContent>
            <CtaImage url={booklet.asset.file.url} altText={booklet.asset.description} />
          </FullWidthCta>
        )}

        {banner !== undefined && (
          <Banner reactRouterTo={`${banner.url}`} target="_blank">
            <BannerContent>
              <h3>{banner.title}</h3>
              <p>{banner.body}</p>
              <Button variant="text" onClick={() => {}}>
                {banner.ctaCopy} <ButtonArrow />
              </Button>
            </BannerContent>
          </Banner>
        )}

        <ArticleListing tagType="pillarTags" tags={["PhysicalActivity", "Football"]} heading={<h2>Hot off the press</h2>} />
      </BodyContent>
    </Body>
  );
};
